import {Component, OnInit, signal} from '@angular/core';
import {DecorationsService} from '../services/decorations/decorations.service';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {Decoration} from '../classes/decoration.class';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {DecorationGroupOverviewComponent} from "./decoration-group-overview/decoration-group-overview.component";

@Component({
    selector: 'app-decorations-overview',
    templateUrl: './decorations-overview.component.html',
    styleUrls: ['./decorations-overview.component.scss'],
    imports: [
        VvrIconComponent,
        RouterLink,
        MatTooltip,
        DecorationGroupOverviewComponent
    ]
})
export class DecorationsOverviewComponent implements OnInit {

    readonly decorationGroups = signal<{
        group: string,
        order: number,
        decorations: Decoration[]
    }[]>([]);

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private decorationsService: DecorationsService
    ) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.decorationsService.getList().then(decorations => {
                const groupsArray = [];
                const groups = decorations.map(d => d.decoration_group)
                    .filter((value, index, self) => self.indexOf(value) === index);

                groups.forEach(group => {
                    const decorationGroup = decorations.filter(d => d.decoration_group === group);
                    groupsArray.push({
                        decorations: decorationGroup,
                        group: group,
                        order: decorationGroup[0]?.order
                    });
                });

                this.decorationGroups.set(groupsArray);
            });
        });
    }

    openDecoration(decoration) {
        this.router.navigate([`decorations`, decoration.id]);
    }

}
